// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/react-image-gallery/styles/css/image-gallery.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg%20opacity%3D%271%27%20xmlns%3D%27http%3A//www.w3.org/2000/svg%27%20viewBox%3D%270%200%2016%2016%27%20fill%3D%27%23f00%27%3E%3Cpath%20d%3D%27M11.354%201.646a.5.5%200%200%201%200%20.708L5.707%208l5.647%205.646a.5.5%200%200%201-.708.708l-6-6a.5.5%200%200%201%200-.708l6-6a.5.5%200%200%211%20.708%200z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg%20opacity%3D%271%27%20xmlns%3D%27http%3A//www.w3.org/2000/svg%27%20viewBox%3D%270%200%2016%2016%27%20fill%3D%27%23f00%27%3E%3Cpath%20d%3D%27M4.646%201.646a.5.5%200%200%201%20.708%200l6%206a.5.5%200%200%201%200%20.708l-6%206a.5.5%200%200%201-.708-.708L10.293%208%204.646%202.354a.5.5%200%200%201%200-.708z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --bg-primary: #f8f8f8;
    --font-primary: #212529;
    --cookie-font: #8a1717;
    --secondary-text: #c62828;
    --footer-bg: #343a40;
    --footer-font: #f8f9fa;
    --link: #F2F2F2;
    --link-hover: #545d65;
    --link-active: #7f8a93;
    --link-secondary: #c62828;
    --link-secondary-hover: #ff5f52;
    --link-secondary-active: #a60000;
    --link-secondary-visited: #c62828;
}

* {
    font-family: Roboto, sans-serif !important
}

.darkLink {
    color: var(--link-secondary) !important
}

.darkLink:hover {
    color: var(--link-secondary-hover) !important
}

.darkLink:active {
    color: var(--link-secondary-active) !important
}

.logo {
    width: 400px;
    margin: auto !important;
    pointer-events: none;
}

.header {
    width: 100vw;
    height: 200px
}

.bgBanner {
    object-fit: cover;
    opacity: .6;
    pointer-events: none;
}

.fullHeight {
    height: 100%
}

.fullWidth {
    width: 100%
}

.flexColumn {
    display: flex;
    flex-direction: column
}

.flexRow {
    display: flex;
    flex-direction: row
}

.bgBannerWrapper {
    position: absolute;
    top: 0;
    z-index: -1;
    height: 200px;
    width: 100vw
}

.navbar {
    height: 200px;
    padding: 0;
    width: 100vw
}

.alignContentCenter {
    align-items: center;
    justify-content: space-evenly
}

.navbar-nav {
    font-weight: 700;
    width: fit-content;
    min-width: 70% !important;
    padding:auto;
    bottom: 0
}

.marginAuto {
    margin: auto
}
.nav-fill {
    justify-content: space-around;
    display: flex;
    align-items: center;

}
.nav-link {
    bottom: 0;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border: 0 solid;
    color: var(--font-primary) !important;
    font-size: 20px;
    width: auto;
}

.nav-link:hover {
    color: red !important
}

.nav-link.active {
    border-bottom: solid 2px red;
    color: red !important
}

.nav-item:hover {
    color: red !important;

    > .nav-link {
        color: red !important
    }
}

.nav-item.active {
    border-bottom: solid 2px red;
    color: red !important;

    > .nav-link {
        color: red !important
    }
}

.offcanvas-header .btn-close {
    margin-right: 20px;
    width: 0;
    position: absolute;
    right: 20px
}

.offcanvas-body {
    height: fit-content;
}

.offcanvas {
    height: fit-content !important;
}

.footer {
    background-color: var(--footer-bg);
    max-height: 500px;
    position: absolute;
    bottom: 0;
    color: var(--footer-font) !important
}

.page {
    position: relative;
    min-height: 120vh
}

.content {
    height: fit-content;
    padding-bottom: 500px;
    width: 90%
}

.footerTop {
    height: 20%;
    padding: 15px;
    font-weight: 700;
    font-size: 20px
}

.footerCenter {
    padding: 25px;
    height: 65%;
    justify-content: space-evenly;
    border-bottom: 1px solid gray;
    border-top: 1px solid gray
}

.footerColumn {
    width: 30%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
}

.footerColumnTitle {
    font-size: 24px;
    height: 25%;
}

.socials {
    width: 50%;
    justify-content: space-evenly
}

.address {
    font-size: 16px;
}

.addressRow {
    padding-top: 5px;
    padding-bottom: 5px
}

.addressRow svg {
    margin-left: 25%
}
.addressRow a{
    margin-left: 5%;
}
a {
    text-decoration: none;
    color: var(--link)
}

a:hover {
    color: var(--link-hover)
}

a:active {
    color: var(--link-active)
}

.contact {
    text-decoration: underline
}

.footerBottom {
    height: 20%;
    padding: 25px;
    justify-content: space-around;
    align-items: center
}

.legal {
    font-size: 18px;
    padding: 10px;
    border-bottom: 1px solid #f5f5f5;
    border-top: 1px solid #f5f5f5;
    color: var(--link);
    margin-top: 15px;
    text-decoration: none
}
.loadingSpinner {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh
}
.legal:hover {
    color: var(--link-hover);
    border-color: var(--link-hover)
}

.impressum {
    padding-top: 100px;
    width: 50%;
    margin: auto
}

.impressumParagraph {
    text-align: center;
    font-size: 12px;
    line-height: 12px
}

.copyright {
    font-size: 12px
}

.blockTop {
    justify-content: flex-start;
    align-items: flex-start !important
}

.contactButton {
    color: var(--link);
    background-color: #000;
    border-radius: 5px;
    width: fit-content;
    height: fit-content;
    padding: 10px;
    -webkit-user-select: none;
    user-select: none;
    transition: .2s;
    margin-top: 20px
}

.contactButton:hover {
    background-color: #363636
}

.contactButton:active {
    box-shadow: inset 8px 10px 10px 1px rgba(0, 0, 0, .5)
}

.contactButtonWrapper {
    width: 100%;
}

.carouselSide {
    width: 100%;
    height: fit-content;
    height: -moz-fit-content;
}

.machine {
    aspect-ratio: 16/9;
    color: black !important
}

.machineBG {
    background-color: var(--footer-bg);
}
.machine img {
    width: 100%;
    height: 100%;
}
.carousel-caption {
    color: var(--link);
    height: fit-content;
    padding: 10px;
    max-width: 260px;
    bottom: 0;
    left: 0;
    font-size: 16px;
    background-color: rgba(0, 0, 0, .76)
}
.carousel-control-prev-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});

}
.carousel-control-next-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}


    .performances {
    padding: 50px;
    margin: 30px auto auto
}

.performanceRow {
    width: 100%;
}
.note {
    width: fit-content;
}
.performanceRow p {
    margin-left: 10px;
    font-size: 16px !important
}

.alignTextCenter {
    text-align: center;
}

.block {
    margin-top: 50px;
    padding: 20px;
    width: 100%;
    height: fit-content;
    justify-content: space-evenly;
    align-items: center;

}

.blockLeft {
    width: 45%;
}

.blockImage {
    height: fit-content;
    border-radius: 5px
}

.title {
    font-size: 40px;
    font-weight: 700;
    margin: 50px auto 20px;
    background-color: #eeeeee;
    color: #131313;
    padding: 20px;
    text-align: center;
    border: 1px solid #ff5050;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    transform: skew(-10deg);
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.5);
    width: 60%;
}

.contactWrapper {
    height: fit-content;
}

.contactAddress {
    width: 35%;
    height: fit-content;
}

.contactForm {
    width: 45%;
    height: fit-content;
}

form div {
    margin-top: 10px
}

.alert {
    width: 30%;
    position: absolute;
    top: 200px;
    right: 0
}

.cookies {
    z-index: 2;
    width: 100%;
    height: fit-content;
    background-color: rgb(0, 0, 0);
    color: var(--cookie-font);
    font-size: 16px;
    padding: 10px;
    position: fixed;
    bottom: 0;
    align-items: center;
    justify-content: space-between
}

.cookieButton {
    position: relative;
    float: right;
    border-radius: 15px;
    border: 0px;
    background-color: whitesmoke;
    -webkit-user-select: none;
            user-select: none;
}

.cookieButton:hover {
    background-color: #c9c9c9;
}

.cookieButton:active {
    background-color: #ababab;
}

.galleryPart {
    width: 100%;
    height: fit-content;
}

.image-gallery-thumbnail {
    height: 200px !important;
    width: fit-content !important;
    max-width: 30% !important;
    aspect-ratio: auto!important;
    -webkit-user-select: none;
    user-select: none;
    margin: 0 10px
}

.image-gallery-thumbnail * {
    height: 100%;
    width: 100%;
    /*aspect-ratio: auto 16/9;*/
}

.galleryImageBigWrapper {
    width: 800px;
    aspect-ratio: 16/9;
    margin: auto
}

.image-gallery-image {
    height: 400px !important
}

.galleryTitle {
    font-size: 40px;
    font-weight: 700;
    margin-top: 50px;
    margin-bottom: 20px;
    text-align: left;
}

.fourOhFour {
    font-weight: 1000;
    font-size: 120px !important
}

.notFound {
    height: 50vh;
}

.fourOhFourButton {
    width: 200px;
    height: 50px;
}

.fourOhFourButton:hover {
    background-color: #363636
}


.menubutton {
    background-color: #000 !important;
    margin-bottom: 20px !important;
    border-color: red !important
}

.menubutton:active {
    background-color: red !important
}

@media screen and (max-width: 800px) {
    .image-gallery-image {
        height: 200px !important
    }

    .image-gallery-thumbnail-image {
        height: 100px !important
    }

    .logo {
        width: 60%;
        margin-left: 20% !important;
    }

    .nav-link {
        font-size: 16px !important;
        max-width: 40% !important;
    }

    .navbar-nav {
        width: 100vw;
    }

    .offcanvas-top {
        width: 100vw;
    }

    .block {
        flex-direction: column
    }

    .content {
        width: 100%;
        padding-bottom: 550px;
    }

    .blockLeft {
        width: 100%;
        text-align: left;
        margin-bottom: 20px
    }

    .blockRight {
        width: 100%;
        text-align: left;
    }

    .footer {
        min-height: 400px;
        height: fit-content!important;
        max-height: 550px;
    }

    .footerCenter {
        display: flex;
        flex-direction: column
    }

    .footerColumn {
        width: 100%;
        margin: auto;
        padding-bottom: 15px;
    }

    .footerColumnTitle {
        font-size: 20px
    }

    .footerColumnContent {
        font-size: 10px;
        text-align: left;
    }

    .addressRow {
        font-size: 14px !important;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start
    }

    .addressRow svg {
        margin-left: 5%
    }

    .addressRow a {
        margin-left: 10px;
        text-align: left
    }

    .footerTop {
        font-size: 16px;
        padding: 5px;
        height: fit-content!important;
    }

    .footerBottom {
        font-size: 12px;
        padding: 5px;
        height: fit-content!important;
    }

    .footerCenter {
        padding: 5px;
        height: fit-content!important;
    }

    .carouselSide {
        width: 90%;
        margin: auto;
        height: fit-content;
        height: -moz-fit-content;
    }

    .carousel {
        width: 100% !important;
        aspect-ratio: 16/9 !important
    }

    .machine {
        width: 100%;
        height: fit-content;
        min-height: 200px !important;
        background-color: #444
    }

    .carousel-caption {
        top: 0;
        right: 0;
        left: auto;
        font-size: 10px;
        max-width: 50%;
        padding: 2px;
    }

    .carousel-caption h4 {
        font-size: 12px;
    }

    .carousel-caption * {
        margin: 0;
    }

    .technology {
        width: 100%;
        padding-top: 20px
    }

    .performances {
        padding: 5px
    }

    .performanceRow {
        width: 80%;
    }
    .performanceRow p {
        width: 80%;
        font-size: 14px !important;
    }

    .contactWrapper {
        flex-direction: column
    }

    .contactAddress {
        margin: auto;
        width: 90%;
        font-size: 14px;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        text-align: left;
    }

    .contactForm {
        width: 90%;
        font-size: 14px;
        margin: auto
    }

    .image-gallery {
        height: fit-content;
    }

    .image-gallery-thumbnails-wrapper {
        height: fit-content !important;
    }

    .image-gallery-thumbnail {
        height: fit-content !important;
        max-width: 30% !important;
    }

    .contactCol {
        width: 33%
    }

    .address {
        width: fit-content;
        margin: auto
    }
    .title {
        font-size: 20px;
    }

}


.performanceTable {
    border-collapse: collapse;
    width: 40%;
    margin-bottom: 25px;
    color: #333;
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    border: 1px solid gray;


    & th {
        background-color: rgba(255, 97, 97, 0.8);
        text-align: left;
        font-weight: 700;
        width: 60%;
        padding: 10px;
    }

    & td {
        padding: 10px;
    }

    & tr:nth-child(even) {
        background-color: #d7d7d7;
    }
}
.dropdownItem {
    color: black;
    font-weight: bold;
    padding-top: 8px;
    padding-bottom: 8px;
}
.dropdownItem:hover {
    color: red;
}
.dropdown-menu {
    padding: 0;
}
@media screen and (max-width: 767px) {
    .performanceTable {
        display: block;


        & tr {
            display: block;
        }

        & tr:nth-child(even) {
            background-color: #ffffff;
        }

        & th,
        td {
            display: block;
            text-align: left;
        }

        & th {
            width: 100%;
            padding: 5px;
        }

        & th:last-child,
        td:last-child {
            padding-right: 15px;
        }
    }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAGA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;IACtB,yBAAyB;IACzB,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;IACf,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;IAC/B,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IAEI,iBAAiB;IACjB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IAGI,aAAa;IAIb;AACJ;;AAEA;IAGI,aAAa;IAIb;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb,UAAU;IACV;AACJ;;AAEA;IAGI,mBAAmB;IAGnB;AACJ;;AAEA;IACI,gBAAgB;IAGhB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;AACA;IACI,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;;AAEvB;AACA;IACI,SAAS;IACT,4BAA4B;IAC5B,6BAA6B;IAC7B,eAAe;IACf,qCAAqC;IACrC,eAAe;IACf,WAAW;AACf;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,qBAAqB;;IAErB;QACI;IACJ;AACJ;;AAEA;IACI,4BAA4B;IAC5B,qBAAqB;;IAErB;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB;AACJ;;AAEA;IAGI,mBAAmB;AACvB;;AAEA;IAGI,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IAGI,mBAAmB;IACnB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,WAAW;IAGX,6BAA6B;IAC7B,6BAA6B;IAC7B;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IAGZ,aAAa;IAIb,sBAAsB;IAGtB,2BAA2B;IAG3B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,UAAU;IAGV;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;AACA;IACI,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IAEb,6BAA6B;IAG7B;AACJ;;AAEA;IACI,eAAe;IACf,aAAa;IACb,gCAAgC;IAChC,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;AACA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IAGI,2BAA2B;IAG3B;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAGlB,kBAAkB;IAGlB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IAGzB,iBAAiB;IAEjB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;IAEnB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kCAAkC;AACtC;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;IAGlB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,OAAO;IACP,eAAe;IACf;AACJ;AACA;IACI,yDAAuW;;AAE3W;AACA;IACI,yDAAgW;AACpW;;;IAGI;IACA,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;IAGX,mBAAmB;IAGnB,6BAA6B;IAG7B,mBAAmB;;AAEvB;;AAEA;IACI,UAAU;AACd;;AAEA;IAGI,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,uBAAuB;IACvB,2CAA2C;IAC3C,UAAU;AACd;;AAEA;IAGI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IAGV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IAGV,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IAGX,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,eAAe;IACf,SAAS;IAGT,mBAAmB;IAGnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,4BAA4B;IAC5B,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IAGX,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IAGxB,6BAA6B;IAC7B,yBAAyB;IACzB,4BAA4B;IAC5B,yBAAyB;IAGzB,iBAAiB;IACjB;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI;AACJ;;;AAGA;IACI,iCAAiC;IACjC,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;QAC1B,yBAAyB;IAC7B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QAII;IACJ;;IAEA;QACI,WAAW;QACX,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QAGjB,6BAA6B;QAC7B,iBAAiB;IACrB;;IAEA;QAGI,aAAa;QAIb;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,oBAAoB;IACxB;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;QAC1B,WAAW;QAGX,aAAa;QAIb,mBAAmB;QAGnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,eAAe;QACf,YAAY;QAGZ,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,YAAY;QAGZ,6BAA6B;IACjC;;IAEA;QACI,YAAY;QAGZ,6BAA6B;IACjC;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,mBAAmB;QAEnB,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI,WAAW;QAGX,mBAAmB;QACnB,4BAA4B;QAC5B;IACJ;;IAEA;QACI,MAAM;QACN,QAAQ;QACR,UAAU;QACV,eAAe;QACf,cAAc;QACd,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;IACd;IACA;QACI,UAAU;QACV,0BAA0B;IAC9B;;IAEA;QAII;IACJ;;IAEA;QACI,YAAY;QACZ,UAAU;QACV,eAAe;QAGf,aAAa;QAIb,mBAAmB;QAGnB,6BAA6B;QAC7B,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,eAAe;QACf;IACJ;;IAEA;QAGI,mBAAmB;IACvB;;IAEA;QAGI,8BAA8B;IAClC;;IAEA;QAGI,8BAA8B;QAC9B,yBAAyB;IAC7B;;IAEA;QACI;IACJ;;IAEA;QAGI,kBAAkB;QAClB;IACJ;IACA;QACI,eAAe;IACnB;;AAEJ;;;AAGA;IACI,yBAAyB;IACzB,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;;;IAGtB;QACI,wCAAwC;QACxC,gBAAgB;QAChB,gBAAgB;QAChB,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI;QACI,cAAc;;;QAGd;YACI,cAAc;QAClB;;QAEA;YACI,yBAAyB;QAC7B;;QAEA;;YAEI,cAAc;YACd,gBAAgB;QACpB;;QAEA;YACI,WAAW;YACX,YAAY;QAChB;;QAEA;;YAEI,mBAAmB;QACvB;IACJ;AACJ","sourcesContent":["@import \"~react-image-gallery/styles/css/image-gallery.css\";\n@import 'bootstrap/dist/css/bootstrap.min.css';\n\n:root {\n    --bg-primary: #f8f8f8;\n    --font-primary: #212529;\n    --cookie-font: #8a1717;\n    --secondary-text: #c62828;\n    --footer-bg: #343a40;\n    --footer-font: #f8f9fa;\n    --link: #F2F2F2;\n    --link-hover: #545d65;\n    --link-active: #7f8a93;\n    --link-secondary: #c62828;\n    --link-secondary-hover: #ff5f52;\n    --link-secondary-active: #a60000;\n    --link-secondary-visited: #c62828;\n}\n\n* {\n    font-family: Roboto, sans-serif !important\n}\n\n.darkLink {\n    color: var(--link-secondary) !important\n}\n\n.darkLink:hover {\n    color: var(--link-secondary-hover) !important\n}\n\n.darkLink:active {\n    color: var(--link-secondary-active) !important\n}\n\n.logo {\n    width: 400px;\n    margin: auto !important;\n    pointer-events: none;\n}\n\n.header {\n    width: 100vw;\n    height: 200px\n}\n\n.bgBanner {\n    -o-object-fit: cover;\n    object-fit: cover;\n    opacity: .6;\n    pointer-events: none;\n}\n\n.fullHeight {\n    height: 100%\n}\n\n.fullWidth {\n    width: 100%\n}\n\n.flexColumn {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column\n}\n\n.flexRow {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: row;\n    flex-direction: row\n}\n\n.bgBannerWrapper {\n    position: absolute;\n    top: 0;\n    z-index: -1;\n    height: 200px;\n    width: 100vw\n}\n\n.navbar {\n    height: 200px;\n    padding: 0;\n    width: 100vw\n}\n\n.alignContentCenter {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-justify-content: space-evenly;\n    -ms-flex-pack: space-evenly;\n    justify-content: space-evenly\n}\n\n.navbar-nav {\n    font-weight: 700;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n    min-width: 70% !important;\n    padding:auto;\n    bottom: 0\n}\n\n.marginAuto {\n    margin: auto\n}\n.nav-fill {\n    justify-content: space-around;\n    display: flex;\n    align-items: center;\n\n}\n.nav-link {\n    bottom: 0;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n    border: 0 solid;\n    color: var(--font-primary) !important;\n    font-size: 20px;\n    width: auto;\n}\n\n.nav-link:hover {\n    color: red !important\n}\n\n.nav-link.active {\n    border-bottom: solid 2px red;\n    color: red !important\n}\n\n.nav-item:hover {\n    color: red !important;\n\n    > .nav-link {\n        color: red !important\n    }\n}\n\n.nav-item.active {\n    border-bottom: solid 2px red;\n    color: red !important;\n\n    > .nav-link {\n        color: red !important\n    }\n}\n\n.offcanvas-header .btn-close {\n    margin-right: 20px;\n    width: 0;\n    position: absolute;\n    right: 20px\n}\n\n.offcanvas-body {\n    height: -webkit-fit-content;\n    height: -moz-fit-content;\n    height: fit-content;\n}\n\n.offcanvas {\n    height: -webkit-fit-content !important;\n    height: -moz-fit-content !important;\n    height: fit-content !important;\n}\n\n.footer {\n    background-color: var(--footer-bg);\n    max-height: 500px;\n    position: absolute;\n    bottom: 0;\n    color: var(--footer-font) !important\n}\n\n.page {\n    position: relative;\n    min-height: 120vh\n}\n\n.content {\n    height: -webkit-fit-content;\n    height: -moz-fit-content;\n    height: fit-content;\n    padding-bottom: 500px;\n    width: 90%\n}\n\n.footerTop {\n    height: 20%;\n    padding: 15px;\n    font-weight: 700;\n    font-size: 20px\n}\n\n.footerCenter {\n    padding: 25px;\n    height: 65%;\n    -webkit-box-pack: space-evenly;\n    -ms-flex-pack: space-evenly;\n    justify-content: space-evenly;\n    border-bottom: 1px solid gray;\n    border-top: 1px solid gray\n}\n\n.footerColumn {\n    width: 30%;\n    height: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.footerColumnTitle {\n    font-size: 24px;\n    height: 25%;\n}\n\n.socials {\n    width: 50%;\n    -webkit-box-pack: space-evenly;\n    -ms-flex-pack: space-evenly;\n    justify-content: space-evenly\n}\n\n.address {\n    font-size: 16px;\n}\n\n.addressRow {\n    padding-top: 5px;\n    padding-bottom: 5px\n}\n\n.addressRow svg {\n    margin-left: 25%\n}\n.addressRow a{\n    margin-left: 5%;\n}\na {\n    text-decoration: none;\n    color: var(--link)\n}\n\na:hover {\n    color: var(--link-hover)\n}\n\na:active {\n    color: var(--link-active)\n}\n\n.contact {\n    text-decoration: underline\n}\n\n.footerBottom {\n    height: 20%;\n    padding: 25px;\n    -ms-flex-pack: distribute;\n    justify-content: space-around;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center\n}\n\n.legal {\n    font-size: 18px;\n    padding: 10px;\n    border-bottom: 1px solid #f5f5f5;\n    border-top: 1px solid #f5f5f5;\n    color: var(--link);\n    margin-top: 15px;\n    text-decoration: none\n}\n.loadingSpinner {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh\n}\n.legal:hover {\n    color: var(--link-hover);\n    border-color: var(--link-hover)\n}\n\n.impressum {\n    padding-top: 100px;\n    width: 50%;\n    margin: auto\n}\n\n.impressumParagraph {\n    text-align: center;\n    font-size: 12px;\n    line-height: 12px\n}\n\n.copyright {\n    font-size: 12px\n}\n\n.blockTop {\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n    -webkit-box-align: start !important;\n    -ms-flex-align: start !important;\n    align-items: flex-start !important\n}\n\n.contactButton {\n    color: var(--link);\n    background-color: #000;\n    border-radius: 5px;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n    height: -webkit-fit-content;\n    height: -moz-fit-content;\n    height: fit-content;\n    padding: 10px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-transition: .2s;\n    transition: .2s;\n    margin-top: 20px\n}\n\n.contactButton:hover {\n    background-color: #363636\n}\n\n.contactButton:active {\n    box-shadow: inset 8px 10px 10px 1px rgba(0, 0, 0, .5)\n}\n\n.contactButtonWrapper {\n    width: 100%;\n}\n\n.carouselSide {\n    width: 100%;\n    height: fit-content;\n    height: -webkit-fit-content;\n    height: -moz-fit-content;\n}\n\n.machine {\n    aspect-ratio: 16/9;\n    color: black !important\n}\n\n.machineBG {\n    background-color: var(--footer-bg);\n}\n.machine img {\n    width: 100%;\n    height: 100%;\n}\n.carousel-caption {\n    color: var(--link);\n    height: -webkit-fit-content;\n    height: -moz-fit-content;\n    height: fit-content;\n    padding: 10px;\n    max-width: 260px;\n    bottom: 0;\n    left: 0;\n    font-size: 16px;\n    background-color: rgba(0, 0, 0, .76)\n}\n.carousel-control-prev-icon {\n    background-image: url(\"data:image/svg+xml,%3Csvg%20opacity%3D'1'%20xmlns%3D'http%3A//www.w3.org/2000/svg%27%20viewBox%3D%270%200%2016%2016%27%20fill%3D%27%23f00%27%3E%3Cpath%20d%3D%27M11.354%201.646a.5.5%200%200%201%200%20.708L5.707%208l5.647%205.646a.5.5%200%200%201-.708.708l-6-6a.5.5%200%200%201%200-.708l6-6a.5.5%200%200%211%20.708%200z%27/%3E%3C/svg%3E\");\n\n}\n.carousel-control-next-icon {\n    background-image: url(\"data:image/svg+xml,%3Csvg%20opacity%3D'1'%20xmlns%3D'http%3A//www.w3.org/2000/svg'%20viewBox%3D'0%200%2016%2016'%20fill%3D'%23f00'%3E%3Cpath%20d%3D'M4.646%201.646a.5.5%200%200%201%20.708%200l6%206a.5.5%200%200%201%200%20.708l-6%206a.5.5%200%200%201-.708-.708L10.293%208%204.646%202.354a.5.5%200%200%201%200-.708z'/%3E%3C/svg%3E\");\n}\n\n\n    .performances {\n    padding: 50px;\n    margin: 30px auto auto\n}\n\n.performanceRow {\n    width: 100%;\n}\n.note {\n    width: fit-content;\n}\n.performanceRow p {\n    margin-left: 10px;\n    font-size: 16px !important\n}\n\n.alignTextCenter {\n    text-align: center;\n}\n\n.block {\n    margin-top: 50px;\n    padding: 20px;\n    width: 100%;\n    height: -webkit-fit-content;\n    height: -moz-fit-content;\n    height: fit-content;\n    -webkit-box-pack: space-evenly;\n    -ms-flex-pack: space-evenly;\n    justify-content: space-evenly;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n\n}\n\n.blockLeft {\n    width: 45%;\n}\n\n.blockImage {\n    height: -webkit-fit-content;\n    height: -moz-fit-content;\n    height: fit-content;\n    border-radius: 5px\n}\n\n.title {\n    font-size: 40px;\n    font-weight: 700;\n    margin: 50px auto 20px;\n    background-color: #eeeeee;\n    color: #131313;\n    padding: 20px;\n    text-align: center;\n    border: 1px solid #ff5050;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n    transform: skew(-10deg);\n    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.5);\n    width: 60%;\n}\n\n.contactWrapper {\n    height: -webkit-fit-content;\n    height: -moz-fit-content;\n    height: fit-content;\n}\n\n.contactAddress {\n    width: 35%;\n    height: -webkit-fit-content;\n    height: -moz-fit-content;\n    height: fit-content;\n}\n\n.contactForm {\n    width: 45%;\n    height: -webkit-fit-content;\n    height: -moz-fit-content;\n    height: fit-content;\n}\n\nform div {\n    margin-top: 10px\n}\n\n.alert {\n    width: 30%;\n    position: absolute;\n    top: 200px;\n    right: 0\n}\n\n.cookies {\n    z-index: 2;\n    width: 100%;\n    height: -webkit-fit-content;\n    height: -moz-fit-content;\n    height: fit-content;\n    background-color: rgb(0, 0, 0);\n    color: var(--cookie-font);\n    font-size: 16px;\n    padding: 10px;\n    position: fixed;\n    bottom: 0;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    justify-content: space-between\n}\n\n.cookieButton {\n    position: relative;\n    float: right;\n    border-radius: 15px;\n    border: 0px;\n    background-color: whitesmoke;\n    user-select: none;\n}\n\n.cookieButton:hover {\n    background-color: #c9c9c9;\n}\n\n.cookieButton:active {\n    background-color: #ababab;\n}\n\n.galleryPart {\n    width: 100%;\n    height: -webkit-fit-content;\n    height: -moz-fit-content;\n    height: fit-content;\n}\n\n.image-gallery-thumbnail {\n    height: 200px !important;\n    width: -webkit-fit-content !important;\n    width: -moz-fit-content !important;\n    width: fit-content !important;\n    max-width: 30% !important;\n    aspect-ratio: auto!important;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    margin: 0 10px\n}\n\n.image-gallery-thumbnail * {\n    height: 100%;\n    width: 100%;\n    /*aspect-ratio: auto 16/9;*/\n}\n\n.galleryImageBigWrapper {\n    width: 800px;\n    aspect-ratio: 16/9;\n    margin: auto\n}\n\n.image-gallery-image {\n    height: 400px !important\n}\n\n.galleryTitle {\n    font-size: 40px;\n    font-weight: 700;\n    margin-top: 50px;\n    margin-bottom: 20px;\n    text-align: left;\n}\n\n.fourOhFour {\n    font-weight: 1000;\n    font-size: 120px !important\n}\n\n.notFound {\n    height: 50vh;\n}\n\n.fourOhFourButton {\n    width: 200px;\n    height: 50px;\n}\n\n.fourOhFourButton:hover {\n    background-color: #363636\n}\n\n\n.menubutton {\n    background-color: #000 !important;\n    margin-bottom: 20px !important;\n    border-color: red !important\n}\n\n.menubutton:active {\n    background-color: red !important\n}\n\n@media screen and (max-width: 800px) {\n    .image-gallery-image {\n        height: 200px !important\n    }\n\n    .image-gallery-thumbnail-image {\n        height: 100px !important\n    }\n\n    .logo {\n        width: 60%;\n        margin-left: 20% !important;\n    }\n\n    .nav-link {\n        font-size: 16px !important;\n        max-width: 40% !important;\n    }\n\n    .navbar-nav {\n        width: 100vw;\n    }\n\n    .offcanvas-top {\n        width: 100vw;\n    }\n\n    .block {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n        flex-direction: column\n    }\n\n    .content {\n        width: 100%;\n        padding-bottom: 550px;\n    }\n\n    .blockLeft {\n        width: 100%;\n        text-align: left;\n        margin-bottom: 20px\n    }\n\n    .blockRight {\n        width: 100%;\n        text-align: left;\n    }\n\n    .footer {\n        min-height: 400px;\n        height: -webkit-fit-content!important;\n        height: -moz-fit-content!important;\n        height: fit-content!important;\n        max-height: 550px;\n    }\n\n    .footerCenter {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n        flex-direction: column\n    }\n\n    .footerColumn {\n        width: 100%;\n        margin: auto;\n        padding-bottom: 15px;\n    }\n\n    .footerColumnTitle {\n        font-size: 20px\n    }\n\n    .footerColumnContent {\n        font-size: 10px;\n        text-align: left;\n    }\n\n    .addressRow {\n        font-size: 14px !important;\n        width: 100%;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n        flex-direction: row;\n        -webkit-box-pack: start;\n        -ms-flex-pack: start;\n        justify-content: flex-start\n    }\n\n    .addressRow svg {\n        margin-left: 5%\n    }\n\n    .addressRow a {\n        margin-left: 10px;\n        text-align: left\n    }\n\n    .footerTop {\n        font-size: 16px;\n        padding: 5px;\n        height: -webkit-fit-content!important;\n        height: -moz-fit-content!important;\n        height: fit-content!important;\n    }\n\n    .footerBottom {\n        font-size: 12px;\n        padding: 5px;\n        height: -webkit-fit-content!important;\n        height: -moz-fit-content!important;\n        height: fit-content!important;\n    }\n\n    .footerCenter {\n        padding: 5px;\n        height: -webkit-fit-content!important;\n        height: -moz-fit-content!important;\n        height: fit-content!important;\n    }\n\n    .carouselSide {\n        width: 90%;\n        margin: auto;\n        height: fit-content;\n        height: -webkit-fit-content;\n        height: -moz-fit-content;\n    }\n\n    .carousel {\n        width: 100% !important;\n        aspect-ratio: 16/9 !important\n    }\n\n    .machine {\n        width: 100%;\n        height: -webkit-fit-content;\n        height: -moz-fit-content;\n        height: fit-content;\n        min-height: 200px !important;\n        background-color: #444\n    }\n\n    .carousel-caption {\n        top: 0;\n        right: 0;\n        left: auto;\n        font-size: 10px;\n        max-width: 50%;\n        padding: 2px;\n    }\n\n    .carousel-caption h4 {\n        font-size: 12px;\n    }\n\n    .carousel-caption * {\n        margin: 0;\n    }\n\n    .technology {\n        width: 100%;\n        padding-top: 20px\n    }\n\n    .performances {\n        padding: 5px\n    }\n\n    .performanceRow {\n        width: 80%;\n    }\n    .performanceRow p {\n        width: 80%;\n        font-size: 14px !important;\n    }\n\n    .contactWrapper {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n        flex-direction: column\n    }\n\n    .contactAddress {\n        margin: auto;\n        width: 90%;\n        font-size: 14px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n        flex-direction: row;\n        -webkit-box-pack: space-evenly;\n        -ms-flex-pack: space-evenly;\n        justify-content: space-evenly;\n        text-align: left;\n    }\n\n    .contactForm {\n        width: 90%;\n        font-size: 14px;\n        margin: auto\n    }\n\n    .image-gallery {\n        height: -webkit-fit-content;\n        height: -moz-fit-content;\n        height: fit-content;\n    }\n\n    .image-gallery-thumbnails-wrapper {\n        height: -webkit-fit-content !important;\n        height: -moz-fit-content !important;\n        height: fit-content !important;\n    }\n\n    .image-gallery-thumbnail {\n        height: -webkit-fit-content !important;\n        height: -moz-fit-content !important;\n        height: fit-content !important;\n        max-width: 30% !important;\n    }\n\n    .contactCol {\n        width: 33%\n    }\n\n    .address {\n        width: -webkit-fit-content;\n        width: -moz-fit-content;\n        width: fit-content;\n        margin: auto\n    }\n    .title {\n        font-size: 20px;\n    }\n\n}\n\n\n.performanceTable {\n    border-collapse: collapse;\n    width: 40%;\n    margin-bottom: 25px;\n    color: #333;\n    font-size: 16px;\n    font-weight: 400;\n    text-align: left;\n    border: 1px solid gray;\n\n\n    & th {\n        background-color: rgba(255, 97, 97, 0.8);\n        text-align: left;\n        font-weight: 700;\n        width: 60%;\n        padding: 10px;\n    }\n\n    & td {\n        padding: 10px;\n    }\n\n    & tr:nth-child(even) {\n        background-color: #d7d7d7;\n    }\n}\n.dropdownItem {\n    color: black;\n    font-weight: bold;\n    padding-top: 8px;\n    padding-bottom: 8px;\n}\n.dropdownItem:hover {\n    color: red;\n}\n.dropdown-menu {\n    padding: 0;\n}\n@media screen and (max-width: 767px) {\n    .performanceTable {\n        display: block;\n\n\n        & tr {\n            display: block;\n        }\n\n        & tr:nth-child(even) {\n            background-color: #ffffff;\n        }\n\n        & th,\n        td {\n            display: block;\n            text-align: left;\n        }\n\n        & th {\n            width: 100%;\n            padding: 5px;\n        }\n\n        & th:last-child,\n        td:last-child {\n            padding-right: 15px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
